import { useCallback, useSyncExternalStore } from 'react';

const STORAGE_KEY = 'hc_user_email';

type Listener = () => void;
const listeners = new Set<Listener>();

function emitChange(): void {
  for (const listener of listeners) listener();
}

function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

/**
 * Autenticazione STUB (Auth0 rimandato — vedi TODO(Auth0) in services/api.ts).
 * L'utente inserisce la propria email, salvata in localStorage e inviata
 * ad ogni richiesta come header `x-user-email`.
 */
export function useAuth(): {
  email: string | null;
  isAuthenticated: boolean;
  login: (email: string) => void;
  logout: () => void;
} {
  const email = useSyncExternalStore(subscribe, getSnapshot);

  const login = useCallback((newEmail: string) => {
    localStorage.setItem(STORAGE_KEY, newEmail.trim());
    emitChange();
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    emitChange();
  }, []);

  return { email, isAuthenticated: email !== null && email.length > 0, login, logout };
}

export function getStoredUserEmail(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}
